module.exports = __webpack_public_path__ + "img/google-play.dc6d3423.png";